import { Sparkle, BellRinging, HandSwipeRight, ListChecks, QrCode, Broadcast, ShoppingBag, Buildings } from "@phosphor-icons/react";

// Curated roadmap. `status` ∈ 'next' (actively being worked on) | 'soon' | 'exploring'
const ITEMS = [
  {
    key: "togo",
    icon: <ShoppingBag size={22} color="#D96C5B" weight="fill" />,
    title: "To-Go orders (in-app)",
    desc: "In-app to-go menu + kitchen tickets. Until it ships, the AI receptionist automatically routes every to-go call to a live team member.",
    status: "next",
  },
  {
    key: "multiloc",
    icon: <Buildings size={22} color="#1E3A2F" weight="fill" />,
    title: "Multi-location — expanded",
    desc: "Switch locations from the sidebar dropdown (shipping now). Coming: consolidated multi-location analytics, per-location tables, and unified guest history.",
    status: "next",
  },
  {
    key: "push",
    icon: <BellRinging size={22} color="#D96C5B" weight="fill" />,
    title: "Real-time host alerts",
    desc: "Web push so hosts hear the 'new guest' chime with their phone locked in an apron pocket.",
    status: "soon",
  },
  {
    key: "swipe",
    icon: <HandSwipeRight size={22} color="#1E3A2F" weight="fill" />,
    title: "Row swipe actions",
    desc: "Swipe a guest right to text ready, left to remove — phone-friendly speed for busy hosts.",
    status: "soon",
  },
  {
    key: "roi-digest",
    icon: <Sparkle size={22} color="#D96C5B" weight="fill" />,
    title: "Weekly ROI digest email",
    desc: "Monday morning email with how many calls the AI handled and dollars saved last week — no dashboard hunt.",
    status: "soon",
  },
  {
    key: "smartadd-op",
    icon: <ListChecks size={22} color="#1E3A2F" weight="fill" />,
    title: "SmartAdd queue panel",
    desc: "See guests who are scheduled to auto-drop onto the waitlist right on the dashboard.",
    status: "soon",
  },
  {
    key: "qr-poster",
    icon: <QrCode size={22} color="#1E3A2F" weight="fill" />,
    title: "Printable QR poster",
    desc: "One-tap PDF turning every table tent into a marketing surface for join + install.",
    status: "exploring",
  },
  {
    key: "toast",
    icon: <Broadcast size={22} color="#5C6B61" weight="fill" />,
    title: "Toast & Square POS sync",
    desc: "Read-only menu pull for AI quotes, plus optional order push for full-service kitchens.",
    status: "exploring",
  },
];

const STATUS_LABEL = { next: "In progress", soon: "Coming soon", exploring: "Exploring" };
const STATUS_STYLE = {
  next: "bg-[#C2D1C1] text-[#1E3A2F] border-[#1E3A2F]/20",
  soon: "bg-[#EEE0B8]/70 text-[#7A5A00] border-[#7A5A00]/20",
  exploring: "bg-white text-[#5C6B61] border-[#E1DFD5]",
};

export default function ComingSoon({ compact = false }) {
  return (
    <section className={compact ? "mt-10" : "px-6 pb-24"} data-testid="coming-soon-section">
      <div className={compact ? "" : "max-w-7xl mx-auto"}>
        <div className="flex items-center gap-2 mb-2">
          <Sparkle size={16} color="#D96C5B" weight="fill" />
          <div className="overline">What we're building next</div>
        </div>
        <h2 className={`${compact ? "text-2xl" : "text-3xl md:text-4xl"} mb-3 max-w-2xl`}>Coming soon to BuzzerAI</h2>
        <p className="text-[#5C6B61] max-w-2xl mb-8">Shipped by working operators. Vote with your feedback — anything with a lot of demand jumps to the top of the list.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {ITEMS.map((it) => (
            <div key={it.key} className="paper-card p-5 flex flex-col gap-2 fade-up" data-testid={`coming-soon-${it.key}`}>
              <div className="flex items-center justify-between">
                {it.icon}
                <span className={`text-[10px] px-2 py-0.5 rounded-full border ${STATUS_STYLE[it.status]}`} data-testid={`coming-soon-status-${it.key}`}>
                  {STATUS_LABEL[it.status]}
                </span>
              </div>
              <div className="font-heading font-extrabold">{it.title}</div>
              <p className="text-sm text-[#5C6B61] leading-snug">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
